// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__WZbAT","selected":"selected__P3ci7"};


//////////////////
// WEBPACK FOOTER
// ./components/yearSelector/style.css
// module id = 1CUU
// module chunks = 0